// The weekly/monthly switch + period dropdown, shared by every report screen so the
// owner's two report windows are selected the same way everywhere.
//
// `allowAll` adds the "Tümü" and "Günlük" segments (the evaluations LIST only): the list is
// a browse surface, not a report, so it defaults to every in-scope call rather than the
// current week and can be narrowed down to a single day (owner, 2026-09-12). The report
// screens leave both off — a report is defined by its week or month.

import type { PeriodKind, PeriodPicker } from '../hooks';

const KIND_LABEL: Record<PeriodKind, string> = {
  all: 'Tümü', day: 'Günlük', week: 'Haftalık', month: 'Aylık',
};

export default function PeriodBar({ picker, right, allowAll }: {
  picker: PeriodPicker; right?: React.ReactNode; allowAll?: boolean;
}) {
  const kinds: PeriodKind[] = allowAll ? ['all', 'day', 'week', 'month'] : ['week', 'month'];
  return (
    <>
      <div className="seg">
        {kinds.map((k) => (
          <button
            key={k}
            type="button"
            className={picker.kind === k ? 'on' : ''}
            onClick={() => picker.setKind(k)}
          >
            {KIND_LABEL[k]}
          </button>
        ))}
      </div>
      {/* No period dropdown in 'all' mode — there is no window to choose. */}
      {picker.kind !== 'all' ? (
        <select className="inp auto" value={picker.id} onChange={(e) => picker.setId(e.target.value)}>
          {picker.options.length === 0 ? <option value="">—</option> : null}
          {picker.options.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
      ) : null}
      {right}
    </>
  );
}
